<div class="container">
    <div class="messageBox">

        <h2>
            We're sorry for the inconvenience. It seems there was an issue processing your request.<br>
            Please reach out to your agent for assistance.<br><br>
            They'll be able to provide you with more information about the status of your payment.
        </h2>

    </div>
</div>